import { ApiService } from "./AppService";
import { ResponseObject } from "../classes/main";

export class AddToCartService {
  apiService = new ApiService();

  public getCart() {
    const rawCart = localStorage.getItem("cart");
    if (rawCart == null) {
      return null;
    }
    return JSON.parse(atob(rawCart));
  }

  public getTotalCount(mainCart: MainCart): number {
    let totalCount = 0;
    mainCart?.cartItemRequestsById.forEach((cart) => {
      totalCount += cart.cartItemRequests.reduce(
        (sum, item) => sum + item.count,
        0
      );
    });
    localStorage.setItem("count", totalCount.toString());
    return totalCount;
  }

  public async addToCart(
    serviceId: number,
    add: boolean,
    cid: number,
    url: any,
    aboutList: any,
    subHeading: any,
    serviceCharge: any,
    productCost: any,
    min: any,
    specialPrice: any,
    specialMessage: any
  ) {
    if (serviceId == null || serviceId === undefined) {
      // throw new Error("serviceId is required");
      alert("serviceId is required");
      return;
    }
    if (cid == null || cid === undefined) {
      // throw new Error("cid is required");
      alert("cid is required");
      return;
    }
    // if (
    //   !subHeading ||
    //   serviceCharge == null ||
    //   productCost == null ||
    //   min == null
    // ) {
    //   alert("All required fields must be provided");
    //   return;
    // }

    // console.log("serviceId :: " + serviceId, cid);
    const rawCart = localStorage.getItem("cart");
    if (rawCart == null) {
      const mainCart: MainCart = new MainCart();
      const cart: Cart = new Cart();
      const cartItem = new CartItem();
      cartItem.sid = serviceId;
      cartItem.count = 1;
      cartItem.ImageUrl = url;
      cartItem.aboutList = aboutList;
      cartItem.subHeading = subHeading;
      cartItem.serviceCharge = serviceCharge;
      cartItem.productCost = productCost;
      cartItem.min = min ?? "";
      cartItem.specialPrice = specialPrice ?? "";
      cartItem.specialMessage = specialMessage ?? "";
      cart.cartItemRequests = [cartItem];
      cart.cid = cid;
      mainCart.cartItemRequestsById = [cart];
      await this.cartStoreInLocalStorage(
        mainCart.cartItemRequestsById[0],
        mainCart
      );
      this.getTotalCount(mainCart);
      return { count: cartItem.count };
    } else {
      const mainCart: MainCart = JSON.parse(atob(rawCart));
      // Check if the cart with the provided cid exists in mainCart
      const cartCidValid = mainCart?.cartItemRequestsById.find(
        (item) => item.cid === cid
      );
      if (cartCidValid) {
        let cartItem = cartCidValid?.cartItemRequests.find(
          (item) => item.sid == serviceId
        );
        if (cartItem == null || cartItem == undefined) {
          cartItem = new CartItem();
          cartItem.sid = serviceId;
          cartItem.count = 1;
          cartItem.ImageUrl = url;
          cartItem.aboutList = aboutList;
          cartItem.subHeading = subHeading;
          cartItem.serviceCharge = serviceCharge;
          cartItem.productCost = productCost;
          cartItem.min = min ?? "";
          cartItem.specialPrice = specialPrice ?? "";
          cartItem.specialMessage = specialMessage ?? "";
          cartCidValid.cartItemRequests.push(cartItem);
        } else {
          if (add) {
            cartItem.count++;
          } else {
            cartItem.count--;
          }
          if (cartItem.count === 6) {
            // alert("You have reached the maximum count of 5 for this item.");
            return { count: 5 };
          }
          if (cartItem?.count <= 0) {
            cartCidValid.cartItemRequests =
              cartCidValid.cartItemRequests.filter(
                (item) => item.sid !== serviceId
              );
          }
          if (cartCidValid.cartItemRequests.length === 0) {
            mainCart.cartItemRequestsById =
              mainCart.cartItemRequestsById.filter((item) => item.cid !== cid);
          }
        }

        await this.cartStoreInLocalStorage(cartCidValid, mainCart);
        this.getTotalCount(mainCart);
        return { count: cartItem.count };
      } else {
        const cart: Cart = new Cart();
        const cartItem = new CartItem();
        cartItem.sid = serviceId;
        cartItem.count = 1;
        cartItem.ImageUrl = url;
        cartItem.aboutList = aboutList;
        cartItem.subHeading = subHeading;
        cartItem.serviceCharge = serviceCharge;
        cartItem.productCost = productCost;
        cartItem.min = min ?? "";
        cartItem.specialPrice = specialPrice ?? "";
        cartItem.specialMessage = specialMessage ?? "";
        cart.cartItemRequests = [cartItem];
        cart.cid = cid;
        if (!mainCart.cartItemRequestsById) {
          mainCart.cartItemRequestsById = []; // Initialize as empty array if not already
        }
        mainCart.cartItemRequestsById.push(cart);
        await this.cartStoreInLocalStorage(cart, mainCart);
        this.getTotalCount(mainCart);
        return { count: cartItem.count };
      }
    }
  }

  public async cartStoreInLocalStorage(cart: Cart, mainCart: MainCart) {
    const responseObject: ResponseObject | undefined =
      await this.apiService.post<ResponseObject>(
        this.apiService.cartCalculation,
        cart
      );
    const cartCalculation: CartCalculationResponse =
      responseObject?.object as CartCalculationResponse;
    cart.totalAmount = cartCalculation.totalAmount;
    cart.totalDiscount = cartCalculation.totalDiscount;
    cart.totalMrp = cartCalculation.totalMrp;
    cart.cashbackSalontymCoins = cartCalculation.cashbackSalontymCoins;
    cart.cartItemRequests.forEach((item) => {
      var cartCalculationItemResponse: CartCalculationItemResponse =
        cartCalculation.cartCalculationItemResponses.find(
          (child) => child.serviceId == item.sid
        )!;
      item.serviceName = this.removeSpecialCharacters(
        cartCalculationItemResponse.serviceName
      );
      item.totalAmount = cartCalculationItemResponse.totalAmount;
      item.totalDiscount = cartCalculationItemResponse.totalDiscount;
      item.totalMrp = cartCalculationItemResponse.totalMrp;
    });
    localStorage.setItem("cart", btoa(JSON.stringify(mainCart)));
  }
  public removeSpecialCharacters(str: string): string {
    return str.replace(/[^\w\s]/gi, "");
  }

  public checkIfAvailable(serviceId: number, cid: number) {
    const rawCart = localStorage.getItem("cart");
    if (rawCart == null) {
      return { count: 0 };
    } else {
      const mainCart: MainCart = JSON.parse(atob(rawCart));
      const cart = mainCart?.cartItemRequestsById.find(
        (cart) => cart.cid === cid
      );
      if (cart) {
        // If the cart with the provided cid exists, find the item with the matching serviceId
        const cartItem = cart.cartItemRequests.find(
          (item) => item.sid === serviceId
        );
        if (cartItem) {
          return { count: cartItem.count };
        } else {
          return { count: 0 };
        }
      } else {
        return { count: 0 }; // Return 0 if no cart with the provided cid is found
      }
    }
  }

  public checkIfAvailableinCart(serviceId: number, cid: number): boolean {
    // Check if we are in a browser environment
    if (typeof window === "undefined") {
      return false; // Return false or a default value if running on the server
    }
    const rawCart = localStorage.getItem("cart");
    if (rawCart == null) {
      return false; // No cart found
    } else {
      try {
        const mainCart: MainCart = JSON.parse(atob(rawCart));
        const cart = mainCart.cartItemRequestsById.find(
          (cart) => cart.cid === cid
        );
        // Check if cartItemRequests exists and has items
        if (
          cart?.cartItemRequests == null ||
          cart.cartItemRequests.length <= 0
        ) {
          return false;
        }
        return cart?.cartItemRequests?.some((item) => item.sid == serviceId);
      } catch (error) {
        console.error("Failed to parse cart data:", error);
        return false; // Return false on parsing error
      }
    }
  }

  public async removeUnavailableServices(
    cid: number,
    unavailableSids: number[]
  ) {
    const rawCart = localStorage.getItem("cart");
    if (!rawCart) return;

    const mainCart: MainCart = JSON.parse(atob(rawCart));

    const updatedMainCart = {
      cartItemRequestsById: mainCart?.cartItemRequestsById?.map((cartGroup) =>
        cartGroup.cid === cid
          ? {
              ...cartGroup,
              cartItemRequests: cartGroup.cartItemRequests.filter(
                (item) => !unavailableSids.includes(item.sid)
              ),
            }
          : cartGroup
      ),
    };

    // Remove empty carts
    updatedMainCart.cartItemRequestsById =
      updatedMainCart.cartItemRequestsById.filter(
        (cartGroup) => cartGroup.cartItemRequests.length > 0
      );

    // Find the updated cart group
    const updatedCartGroup = updatedMainCart.cartItemRequestsById.find(
      (cartGroup) => cartGroup.cid === cid
    );

    if (updatedCartGroup) {
      await this.cartStoreInLocalStorage(updatedCartGroup, updatedMainCart);
      this.getTotalCount(updatedMainCart);
    } else {
      // All items removed, maybe you want to clear cart too
      localStorage.setItem("cart", btoa(JSON.stringify(updatedMainCart)));
      this.getTotalCount(updatedMainCart);
    }
  }
}

export class MainCart {
  cartItemRequestsById: Cart[];
}

export class Cart {
  cid: number;
  cartItemRequests: CartItem[];
  totalAmount: number;
  totalSpecialPrice: number;
  totalspecialDiscount: number;
  totalDiscount: number;
  totalMrp: number;
  extraDiscount: number;
  totalAmountUniversal: number;
  coupon: string;
  offerHeading: string;
  cashbackSalontymCoins: number;
  constructor() {}
}
class CartItem {
  sid: number;
  count: number;
  serviceName: string;
  ImageUrl: string;
  subHeading: string;
  serviceId: number;
  totalAmount: number;
  totalSpecialPrice: number;
  totalspecialDiscount: number;
  totalDiscount: number;
  totalMrp: number;
  totalProductCost: number;
  totalSelectedProductCost: number;
  aboutList: any;
  serviceCharge: number;
  productCost: number;
  min: number;
  specialPrice: number;
  specialMessage: string;
  constructor() {}
}

class CartCalculationResponse {
  public totalAmount: number;
  public totalSpecialPrice: number;
  public totalspecialDiscount: number;
  public totalDiscount: number;
  public totalMrp: number;
  public extraDiscount: number;
  public totalAmountUniversal: number;
  public cashbackSalontymCoins: number;

  public cartCalculationItemResponses: CartCalculationItemResponse[];
}

class CartCalculationItemResponse {
  public serviceId: number;
  public serviceName: string;
  public totalAmount: number;
  public totalSpecialPrice: number;
  public totalDiscount: number;
  public totalMrp: number;
  public totalProductCost: number;
  public totalSelectedProductCost: number;
}
